import { useEffect } from 'react';

/**
 * Closes a surface on the Escape key, but only while it is the active surface.
 *
 * Gating on `active` means a drilldown stacked on top of the (inert) main panel
 * is the only one that responds to Escape — the main panel does not also fire its
 * own `onClose` behind it. The document `keydown` listener is attached only while
 * active and removed on cleanup / when `active` flips to false.
 *
 * @param {boolean} active - Whether this surface is the topmost open one.
 * @param {Function} onClose - Called when Escape is pressed while active.
 * @returns {void}
 */
const useEscapeToClose = (active, onClose) => {
	useEffect(() => {
		if (!active) return undefined;
		const handleKeyDown = (event) => {
			if (event.key === 'Escape') onClose();
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [active, onClose]);
};

export default useEscapeToClose;
